// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import SkeletonLoaderContext from './SkeletonLoaderContext';
import { StyledModuleWrapper, StyledModule } from './PromoModules.style';

const ESSENTIALS = 'essentials';

const userSpecificModuleX = (userType, isPlcc, isLoggedIn) => {
  if (
    (userType === 'plcc' && isPlcc) ||
    (userType === 'mpr' && !isPlcc && isLoggedIn) ||
    (userType === 'guest' && !isLoggedIn)
  ) {
    return true;
  }
  return false;
};

const extractAspectRatios = (aspectRatioStr) => {
  const aspectRatios = {
    aspectRatioD: null,
    aspectRatioT: null,
    aspectRatioM: null,
  };

  const ratioPairs = aspectRatioStr?.split('|');

  ratioPairs?.forEach((pair) => {
    const [key, value] = pair.split('-');
    switch (key) {
      case 'D':
        aspectRatios.aspectRatioD = parseInt(value, 10);
        break;
      case 'T':
        aspectRatios.aspectRatioT = parseInt(value, 10);
        break;
      case 'M':
        aspectRatios.aspectRatioM = parseInt(value, 10);
        break;
      default:
        console.warn(`Unknown key: ${key}`);
    }
  });

  return aspectRatios;
};

const PromoModules = ({
  asPath,
  plpTopPromos,
  isLoggedIn,
  isPlcc,
  viaModule,
  showEssentials,
  dynamicPromoModules: modules,
  currentListingName,
  isPromoForMobile,
  fromHplp,
  setFromHplpFlag,
  isOutfitCarouselPillDesignEnabled,
  currentPathName,
  sbcDesignVariationRectangle,
  sbcDesignVariationCircle,
  isOutfitPillVariationEnabledOnAllPlps,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  return (
    plpTopPromos &&
    plpTopPromos.length &&
    plpTopPromos.map((promo, index) => {
      const { contentId, moduleName, userType, data: slotData, aspectRatio, ...others } = promo;
      const aspectRatioObj = extractAspectRatios(aspectRatio);
      if (!showEssentials && moduleName === ESSENTIALS) return null;
      const Module = modules[moduleName];
      // This is user specific moduleX - eg. For loyalty Banner on PLP
      if (userType && moduleName === 'moduleX') {
        const isUserSpecificModuleX = userSpecificModuleX(userType, isPlcc, isLoggedIn);
        if (isUserSpecificModuleX) {
          // eslint-disable-next-line prefer-destructuring, dot-notation
          const Espot = modules['Espot'];
          return (
            <Espot
              richTextHtml={
                promo.richTextList && promo.richTextList[0] && promo.richTextList[0].text
              }
            />
          );
        }
        return null;
      }
      return (
        Module && (
          <SkeletonLoaderContext.Provider
            value={isOutfitCarouselPillDesignEnabled || isOutfitPillVariationEnabledOnAllPlps}
          >
            <StyledModuleWrapper aspectRatioObj={aspectRatioObj}>
              <StyledModule aspectRatioObj={aspectRatioObj}>
                <Module
                  fullBleed
                  key={contentId}
                  data={promo}
                  asPath={asPath}
                  viaModule={viaModule}
                  currentListingName={currentListingName}
                  isPromoForMobile={isPromoForMobile}
                  fromHplp={fromHplp}
                  setFromHplpFlag={setFromHplpFlag}
                  isPreload={index === 0 || index === 1}
                  currentPathName={currentPathName}
                  sbcDesignVariationRectangle={sbcDesignVariationRectangle}
                  sbcDesignVariationCircle={sbcDesignVariationCircle}
                  isOutfitPillVariationEnabledOnAllPlps={isOutfitPillVariationEnabledOnAllPlps}
                  {...slotData}
                  {...others}
                />
              </StyledModule>
            </StyledModuleWrapper>
          </SkeletonLoaderContext.Provider>
        )
      );
    })
  );
};

PromoModules.propTypes = {
  asPath: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  isPlcc: PropTypes.bool,
  plpTopPromos: PropTypes.arrayOf(
    PropTypes.shape({
      // Only including the most important property
      moduleName: PropTypes.string,
    })
  ),
  viaModule: PropTypes.string,
  showEssentials: PropTypes.bool,
  isPromoForMobile: PropTypes.bool,
  isOutfitCarouselPillDesignEnabled: PropTypes.bool,
  isOutfitPillVariationEnabledOnAllPlps: PropTypes.bool,
};

PromoModules.defaultProps = {
  asPath: '',
  plpTopPromos: [],
  isLoggedIn: false,
  isPlcc: false,
  viaModule: '',
  showEssentials: false,
  isPromoForMobile: false,
  isOutfitCarouselPillDesignEnabled: false,
  isOutfitPillVariationEnabledOnAllPlps: false,
};

export default PromoModules;
